// Общите класове на бутоните/полетата в десния панел на „Конфигурация на маси"
// (отделно от компонентите — Fast Refresh иска файл само с компоненти).

/** Бързите бутони за места под стъпера. */
export const SEAT_CHIPS = [2, 4, 6, 8, 10, 12];

export const FOCUS_RING = "focus:border-brand focus:shadow-[0_0_0_3px_rgba(217,115,13,0.15)]";

export const PRIMARY_BUTTON =
  "flex h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-[10px] border-none bg-brand px-4 text-[14px] font-bold text-white transition-colors duration-150 hover:bg-brand-deep disabled:cursor-not-allowed disabled:opacity-50";

export const SECONDARY_BUTTON =
  "flex h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-[10px] border border-shade-3 bg-surface px-4 text-[13.5px] font-semibold text-ink transition-colors duration-150 hover:bg-fill disabled:cursor-not-allowed disabled:opacity-50";

export const DANGER_BUTTON =
  "flex h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-[10px] border border-danger/40 bg-transparent px-4 text-[13.5px] font-semibold text-danger-ink transition-colors duration-150 hover:bg-danger-tint disabled:cursor-not-allowed disabled:opacity-50";
